import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, admin = false }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null)
    return (
      <div className="flex justify-center py-32" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-sky-600" />
      </div>
    );
  if (!user) return <Navigate to="/entrar" replace state={{ from: location.pathname }} />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
